import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { VisitgridComponent } from './visitgrid/visitgrid.component';
import { VisitgriddetailsComponent } from './visitgriddetails/visitgriddetails.component';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchPipe } from './search.pipe';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { PdfviewerComponent } from './pdfviewer/pdfviewer.component'; 
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ErrorInterceptor, JwtInterceptor } from './_helpers';
import { AuthenticationService } from './_services';
import { appInitializer } from './_services/app-initializer';
import { CustomDateParserFormatter } from './_services/custom-date-parser-formatter';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    VisitgridComponent,
    VisitgriddetailsComponent,
    SearchPipe,
    PdfviewerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    PdfJsViewerModule,
    NgbDatepickerModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthenticationService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
